import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

import character from '../../assets/images/intake/step9/char.svg';
import img5 from '../../assets/images/swot/step4/char.svg';

export const FeedbackSurvey: React.FC = () => {
  const navigate = useNavigate();
  const handleNextButton = () => {
    navigate('/swot/step5');
  };
  return (
    <>
      <div className="character absolute bottom-[-70px] right-[-200px]">
        <img className="" src={character} alt="" />
      </div>
      <div className="text-center px-16">
        <img className="mx-auto mt-5" src={img5} alt="" />
        <p className="mt-8 text-xl">
          At Vero Learning, we believe that access to education and career opportunities should not
          be limited by systemic barriers. That's why we are committed to providing young adults
          with free vocational and skills-building courses, personalized career SWOT analysis
          reports and immediate job placement opportunities.
          <br /> <br />
          Your feedback is important to us, and we would love to hear about your experience using
          our platform. Please take a few minutes to complete our feedback survery so that we can
          continue to improve and provide you with the best possible service.
        </p>
      </div>
      <div className="text-center mt-12">
        <Link
          target="_blank"
          to="https://www.verolearning.com/feedback"
          className="btn-primary !bg-purple-500 mr-3"
        >
          Feedback
        </Link>
        <button onClick={handleNextButton} className="btn-primary">
          Next
        </button>
      </div>
    </>
  );
};
